export default {
  data() {
    return {
      CCAList: [
        {
          label: 'M101',
        },
        {
          label: 'M111',
        },
        {
          label: 'M112',
        },
        {
          label: 'M113',
        },
        {
          label: 'M114',
        },
        {
          label: 'M115',
        },
        {
          label: 'M118',
        },
        {
          label: '121',
        },
        {
          label: '8888',
        },
        {
          label: '9900',
        },
        {
          label: 'S666',
        },
        {
          label: 'M121',
        },
      ],
      searchSchema: [
        // {
        //   label: 'CCA',
        //   itemName: 'cca',
        //   type: 'select',
        //   selectList: [],
        //   allowClear: true,
        // },
        {
          label: 'A/R Date',
          itemName: 'time',
          type: 'rangePicker',
          format: 'YYYY-MM-DD',
        },
      ],
      searchData: {
        cca: '',
        startTime: '',
        endTime: '',
      },
    }
  },
}
